import React from 'react';
import { LinearProgress } from '@mui/material';
import { getCurrencySymbol, toFixedTrunc } from '../../../client/Juno/helpers';
import { currencyColors } from '../../helpers/constant';
import ActionButton from '../ActionButton';
import MoreActionDropdown from '../common/MoreActionDropdown';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

const BalanceActionsPanel = ({
    currencyData,
    actionIcons,
    windowWidth,
    activeCurrencyPage,
    handleActionClick,
    readOnly,
    moreButtonRef,
    menuOpen,
    handleMoreClick,
    handleCloseMenu,
}) => {
    return (
        <div className="h-[256px] bg-modal-bg  rounded-lg border-t border-b border-[#0000001F] dark:border-[#FFFFFF1F] my-[1px] p-6">
            <div>
                <p className="text-section-title text-sm font-semibold">YOUR BALANCE</p>
                <p className="!text-text text-3xl font-semibold mt-3">
                    {getCurrencySymbol(currencyData?.currencyShortName)}{' '}
                    {toFixedTrunc(currencyData?.balanceAmount, activeCurrencyPage === 'crypto' ? 8 : 2)}
                </p>
                <div>
                    <p className="!text-text text-sm font-medium mt-2 mb-1">
                        {toFixedTrunc(currencyData?.holdingPercentage, 2)}%
                    </p>
                    <LinearProgress
                        variant="determinate"
                        value={currencyData?.holdingPercentage}
                        sx={{
                            '&&': {
                                backgroundColor: 'var(--progress-bg)',
                                '& .MuiLinearProgress-bar': {
                                    transform: 'rotateY(180deg)',
                                    backgroundColor: currencyColors.find(
                                        colorItem =>
                                            colorItem?.symbol === currencyData?.currencyShortName,
                                    )?.color,
                                },
                            },
                        }}
                    />
                </div>
                <div className="bg-none pt-6 rounded-xl relative flex flex-nowrap !gap-3 justify-center sm:justify-start mt-1">
                    {[
                        ...(windowWidth >= 640
                            ? actionIcons.slice(0, 7)
                            : activeCurrencyPage === 'crypto'
                              ? actionIcons.slice(0, 7)
                              : actionIcons.slice(0, 4)),
                    ].map(({ key, label, icon, mobileLabel, tooltip }) => (
                        <div
                            key={key}
                            className="flex flex-col items-center justify-center lg:w-full">
                            <ActionButton
                                icon={icon}
                                onClick={() => handleActionClick(key)}
                                text={label?.toUpperCase()}
                                disabled={readOnly}
                                htmlType="button"
                                type="contained"
                                autoWidth={true}
                                shape="rounded-lg"
                                tooltipText=""
                                className="flex flex-col items-center justify-center !bg-secondary !text-text p-3 md:p-6 xl:w-full hover:bg-gray-300 transition flex-shrink-0 rounded-lg"
                                textClass="mt-1 text-[10px] md:text-xs text-center hidden lg:block"
                            />
                            <span className="mt-1 !text-[10px] text-xs text-center text-balanceCard-manage lg:hidden">
                                {key === 'paymentOut'
                                    ? "TPP'S"
                                    : mobileLabel?.toUpperCase() ||
                                      label?.toUpperCase() ||
                                      tooltip?.toUpperCase()}
                            </span>
                        </div>
                    ))}

                    {activeCurrencyPage === 'fiat' && windowWidth <= 640 && (
                        <div className="flex flex-col items-center justify-center lg:w-full">
                            <ActionButton
                                icon={<MoreHorizIcon className="!w-[20px] !h-[20px]" />}
                                onClick={readOnly ? null : handleMoreClick}
                                disabled={readOnly}
                                htmlType="button"
                                type="contained"
                                autoWidth={true}
                                shape="rounded-lg"
                                tooltipText=""
                                className="flex flex-col items-center justify-center !bg-secondary !text-text rounded-lg p-3 md:w-20 sm:w-18 hover:bg-gray-300 transition"
                                textClass="mt-1 text-[10px] md:text-xs text-center hidden lg:block"
                            />
                            <span className="mt-1 !text-[10px] text-xs text-center text-balanceCard-manage lg:hidden">
                                MORE
                            </span>

                            {menuOpen && (
                                <MoreActionDropdown
                                    actions={actionIcons.slice(4, 7)}
                                    onClick={handleActionClick}
                                    onClose={handleCloseMenu}
                                    containerClasses=" !w-[160px] absolute z-2 !opacity-100 -bottom-[100px] right-[0px] rounded-lg !bg-[#FFF] dark:!bg-[#3F3F46] border-t border-divider-text shadow-[0px_5px_14px_rgba(0,0,0,0.15)] dark:shadow-[0px_5px_14px_rgba(0,0,0,0.15)]"
                                    buttonClasses="flex items-center gap-2 w-full !text-balanceCard-manage item-center rounded-lg text-sm font-medium leading-none tracking-[0.14px] uppercase dark:hover:!bg-[#51525C] hover:bg-[#F4F4F5]"
                                />
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default BalanceActionsPanel;
